import { FormControlLabel, Checkbox } from '@mui/material';
import { ModerationActionType } from './models/moderation';
import CardTemplate from './CardTemplate';

export default function MemberActionCard(props: any) {
  const handleBanUser = async () => {
    await props.onAddAction(props.report.id, {
      actionType: ModerationActionType.USER_BAN,
      actionDescription: '',
      proposedReportCategories: props.report.reportCategories,
    });
  };
  const handleChange = (event: any) => {
    if (event.target.checked) handleBanUser();
  };
  const title = "Take action";
  const subtitle = "If a member is posting threats, permanently ban them from the community feature.";
  const body = (
    <FormControlLabel className="ban-checkbox" control={<Checkbox onChange={handleChange} />} label="BAN MEMBER PERMANENTLY" />
  );
  return (
    <CardTemplate title={ title } subtitle={ subtitle } body={ body } />
  );
}